import { render, staticRenderFns } from "./NotifiedUserForm.vue?vue&type=template&id=cb12f764&scoped=true"
import script from "./NotifiedUserForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotifiedUserForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotifiedUserForm.vue?vue&type=style&index=0&id=cb12f764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb12f764",
  null
  
)

export default component.exports